import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reviewResume',
  standalone: true
})
export class ReviewResumePipe implements PipeTransform {

  transform(note: number, ...args: unknown[]): unknown {
    return note ? this.display(note) : 'votre avis';
  }

  display(note: number): string {
    switch (note) {
      case 1:
        return 'Très insatisfait';
      case 2:
        return 'Insatisfait';
      case 3:
        return 'Correct';
      case 4:
        return 'Satisfait';
      case 5:
        return 'Très satisfait';
    }
  }
}
